export interface CustomCursorProps {
    src: string;
}

export const customCursor = (name: CustomCursorProps) => {
    return `url(${name?.src}), auto`;
};
